import React, { useState, useEffect } from "react";
import VersionAlert from "./VersionAlert";
import { VERSION_KEY } from "../../utils/constants";

const VersionNotification = ({ onVersionClick }) => {
  const [showNotification, setShowNotification] = useState(false);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        // Get current version from release notes at root level
        const response = await fetch("/releaseNotes.txt");
        const text = await response.text();
        const currentRelease = JSON.parse(text);
        const currentVersion = currentRelease.version;

        // Get last seen version from localStorage
        const lastSeenVersion = localStorage.getItem(VERSION_KEY);

        // Show notification if versions are different
        if (lastSeenVersion !== currentVersion) {
          setShowNotification(true);
        }
      } catch (error) {
        console.error("Failed to check version:", error);
      }
    };

    checkVersion();
  }, []);

  const handleNotificationClose = async () => {
    setShowNotification(false);
    // Update last seen version in localStorage
    try {
      const response = await fetch("/releaseNotes.txt");
      const text = await response.text();
      const currentRelease = JSON.parse(text);
      localStorage.setItem(VERSION_KEY, currentRelease.version);
    } catch (error) {
      console.error("Failed to update last seen version:", error);
    }
  };

  const handleNotificationClick = () => {
    onVersionClick();
    handleNotificationClose();
  };

  return showNotification ? (
    <VersionAlert
      message="A new version is available! Click to see what's new."
      onClose={handleNotificationClose}
      onClick={handleNotificationClick}
    />
  ) : null;
};

export default VersionNotification;
